import { Text } from "@chakra-ui/react";
import { toLower } from "@/utils/case";
import { convertOrderStatusToNew } from "@/shared/utils";
import { useTranslation } from "react-i18next";
import { OrderSheetStatus } from "@/features/order-sheets/order-sheet.type";

export interface ChangeOrderSheetStatusConfirmMessageProps {
  status?: OrderSheetStatus;
}
export default function ChangeOrderSheetStatusConfirmMessage({
  status,
}: ChangeOrderSheetStatusConfirmMessageProps) {
  const { t } = useTranslation();

  if (status) {
    const text = t("change_status_modal.message", {
      ns: "order_sheet_sets",
    });

    const i = text.indexOf("[");
    const j = text.indexOf("]");

    if (i > -1 && j > -1) {
      return (
        <>
          {text.substring(0, i)}
          {/* 상태 선택 목록과 같은 이름을 쓴다(예: 바이어 승인 필요, 운송 중) */}
          <Text as={"b"}>
            [{t(`order_history:${toLower(convertOrderStatusToNew(status))}`)}]
          </Text>
          {text.substring(j + 1)}
        </>
      );
    }
  }

  return null;
}
